export default __webpack_public_path__ + "static/media/38.fcf38a8f.jpg";